import { ApiTarget } from '../environment/api-environment.model';
import { SharedEnvironment } from '../environment/shared-environment.model';

/**
 * Base URL for one split service.
 *
 * In `monolith` mode every target resolves to `adminApiUrl`, so a service converted to a
 * client produces exactly the URLs it produced before conversion. In `split` mode each
 * target resolves to its own host and no rewriting is needed.
 *
 * Deliberately does not import from `../api-routing/` — that folder is deleted at the end of
 * the burn-down, and this must outlive it.
 */
export function resolveTargetBaseUrl(target: ApiTarget, env: SharedEnvironment): string {
  const monolithBaseUrl = stripTrailingSlash(env.adminApiUrl);

  if (env.apiMode !== 'split') {
    return monolithBaseUrl;
  }

  const splitBaseUrl = env.apiUrls?.[target];
  return splitBaseUrl ? stripTrailingSlash(splitBaseUrl) : monolithBaseUrl;
}

function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}
